<template>
  <div class="form-wrapper">
    <form @submit.prevent="save()">
      <b-form-group label="Nom" label-for="companyName">
        <b-input
            required
            autofocus
            v-model="company.name"
            id="companyName"
            class="mt-2"
        />
      </b-form-group>
      <div class="d-flex justify-content-center align-items-center">
        <b-btn
            type="submit"
            :variant="load ? 'link' : 'secondary'"
            size="lg"
            :disabled="load"
        >
          <span v-if="!load">Enregistrer</span>
          <span v-else><b-spinner small/></span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import {http} from '@/http';

/**
* @vuese
* Formulaire pour les entreprises
* @group COMPONENTS_ADMIN
*/
export default {
  name: 'FormAdminCompany',
  props: {
    // Nom de l'entreprise
    company: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    }
  },
  data() {
    return {
      load: false,
      form: {
        name: ''
      }
    };
  },
  methods: {
    /**
     * @vuese
     * Création d'une nouvelle entreprise
     * @returns {Promise<AxiosResponse<any>>}
     */
    save() {
      let dataSend = JSON.parse(JSON.stringify(this.company));

      this.load = true;

      let url = '/api/company_froms';
      let method = 'post';
      let mode = 'new';
      if (dataSend['@id']) {
        url = dataSend['@id'];
        method = 'put';
        mode = 'update';
      }

      return http[method](url, dataSend).then((res) => {
        // Sauvegarde de l'entreprise
        this.$emit('saved', res.data);
        // Création ou mise à jour
        this.$emit(mode, res.data);
        this.load = false;
        return res;
      });
    }
  }
};
</script>